import React, { useState, useEffect, useCallback } from "react";
import { Form, Button, Select, DatePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import * as zoneActions from "../../../../redux/actions/zone.actions";
import * as dashboardActions from "../../../../redux/actions/dashboard.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { RangePicker } = DatePicker;

const MetricsDashboardFilter = (props) => {
  const [postDataZone, setPostDataZone] = useState(null);
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  
  useEffect(() => {
    if (props.formData){
      form.setFieldsValue(props.formData || null);
    }
  }, [props.formData])

  useEffect(() => {
    postLists()
  }, []);

  const postLists = useCallback(async() => {
    try {
      setLoading(true);
      await props.zoneActions.getZoneListAction();
    } catch (e) {} finally {
      setLoading(false);
    }
  }, [])
  
  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      props.zoneData.map((item) => {zoneData.push({value: item?.storeId, label: item?.zoneName})});
      setPostDataZone(zoneData);
    }
  }, [props.zoneData]);

  const filterChange = useCallback(async (value) => {
    await props.dashboardActions.filterMetricsDashboardAction(value);
  },[])

  return (
    <Form form={form} className="page-list ffr aife" disabled={loading || props?.pageLoader} onFinish={filterChange} layout="vertical" initialValues={{ modifier: 'public', }}>
      <Form.Item
       name={["storeId"]}
       label={(<>Search Zone</>)}
       rules={[{required: true, message: 'Please select zone'}]}

      >
        <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={postDataZone}
          style={{ minWidth: 300,}}
        />
      </Form.Item>
      <Form.Item
       name={["date"]}
       label={"Date"}
      >
        <RangePicker
          allowClear={false}
          showTime={{ format: 'HH:mm' }}
          format="YYYY-MM-DD HH:mm"
        />
      </Form.Item>
      <Button htmlType="submit" loading={loading || props?.pageLoader}>Search <SearchOutlined /></Button>
      {/* <Button onClick={()=>filterChange(null)}>Reset</Button> */}
    </Form>
  );
};

const mapStateToProps = (state) => {
  return { 
    zoneData: state.ZoneReducer.zoneData,
    formData: state.DashboardReducer.metricsDashboardFilter,
    pageLoader: state.DashboardReducer.metricsDashboardLoader,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    dashboardActions: bindActionCreators(dashboardActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MetricsDashboardFilter);

